import { c as _c } from "react/compiler-runtime";
import { Hint } from '@systemeio/ui';
import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { ListIcon } from '@systemeio/ui/icons';
import { twMerge } from 'tailwind-merge';
type Props = {
  additionalChild?: ReactNode;
  disabled?: boolean;
};
const ResourcesBase: FC<PropsWithChildren<Props>> = t0 => {
  const $ = _c(19);
  const {
    additionalChild,
    children,
    disabled
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ListIcon className="fill-text-primary h-6 w-6 scale-75" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("dashboard.funnel.configuration.common.offer_resources.description_popover");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("dashboard.funnel.configuration.common.offer_resources.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="bo-color-[rgb(var(--brand-primary-subtle))] flex flex-col gap-3"><div className="text-text-primary flex flex-row items-center gap-1 text-sm lg:text-[15px]">{t1}<Hint label={t2}>{t3}</Hint></div></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== additionalChild || $[9] !== t4) {
    t5 = <div className="flex flex-col justify-between gap-3 lg:flex-row lg:items-center lg:gap-0">{t4}{additionalChild}</div>;
    $[8] = additionalChild;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = disabled && "pointer-events-none opacity-50";
  let t7;
  if ($[11] !== t6) {
    t7 = twMerge("flex flex-col gap-3 lg:gap-2", t6);
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== children || $[14] !== t7) {
    t8 = <div className={t7}>{children}</div>;
    $[13] = children;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t8) {
    t9 = <div className="flex flex-col gap-3 lg:gap-2">{t5}{t8}</div>;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
export default ResourcesBase;